import { get } from 'lodash';
import { createSelector } from 'reselect';

const root = state => get(state, 'IncomeBracketState');
export const getIncomeBrackets = state =>
  get(root(state), 'incomeBrackets', []);
export const hasIncomeBrackets = createSelector(
  getIncomeBrackets,
  incomeBrackets => incomeBrackets.length > 0
);



// WEBPACK FOOTER //
// ./src/pages/incomebracket/state/selectors.js